export const myTimesheetEmplyeeRequests = {
  id: "my-time-sheet-employee-requests",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "employeeName",
      type: "pipedName",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "projectName",
      type: "text",
      label: "MY_TIMESHEET_PROJECT",
      sort: true,
    },
    {
      id: "clientName",
      type: "text",
      label: "MY_TIMESHEET_CLIENT",
      sort: true,
    },
    {
      id: "workDate",
      type: "text",
      label: "OC_DATE",
      sort: true,
      width: "110px",
    },
    {
      id: "startTime",
      type: "text",
      label: "OC_START_TIME",
      sort: true,
      width: "90px",
    },
    {
      id: "endTime",
      type: "text",
      label: "OC_END_TIME",
      sort: true,
      width: "90px",
    },
    {
      id: "duration",
      type: "text",
      label: "MY_TIMESHEET_DURATION",
      sort: true,
      width: "90px",
    },
    {
      id: "requests",
      type: "myTimesheetBadges",
      label: "OC_REQUESTS",
      width: "120px",
      align: "center",
    },
  ],
};

export const myTimesheetEmplyeeRequestsIsMobile = {
  id: "my-time-sheet-employee-requests",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "employeeName",
      type: "pipedName",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "workDate",
      type: "text",
      label: "OC_DATE",
      align: "center",
    },
    {
      id: "requests",
      type: "myTimesheetBadges",
      label: "OC_REQUESTS",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const myTimesheetFilteredUsers = {
  id: "my-time-sheet-employee-requests",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "employeeName",
      type: "pipedName",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "requestedDuration",
      type: "text",
      label: "MY_TIMESHEET_REQUESTED_DURATION",
    },
    {
      id: "requestedCost",
      type: "text",
      label: "MY_TIMESHEET_REQUESTED_COST",
    },
  ],
};

export const myTimesheetEmplyeeTodaysRequests = {
  id: "my-time-sheet-employee-todays-requests",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "employeeName",
      type: "pipedName",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "projectName",
      type: "text",
      label: "MY_TIMESHEET_PROJECT",
      sort: true,
    },
    {
      id: "clientName",
      type: "text",
      label: "MY_TIMESHEET_CLIENT",
      sort: true,
    },
    {
      id: "startTime",
      type: "text",
      label: "OC_START_TIME",
      sort: true,
    },
    {
      id: "endTime",
      type: "text",
      label: "OC_END_TIME",
      sort: true,
    },
    {
      id: "duration",
      type: "text",
      label: "MY_TIMESHEET_DURATION",
      sort: true,
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      width: "120px",
      align: "center",
    },
  ],
};

export const myTimesheetEmplyeeTodaysRequestsIsMobile = {
  id: "my-time-sheet-employee-todays-requests",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "employeeName",
      type: "pipedName",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const myTimesheetMyRequestsDashboardTable = (
  type: "MY_TIMESHEET_PROJECT" | "OC_COST" | "MY_TIMESHEET_CLIENT",
) => ({
  id: "my-time-sheet-my-requests-dasboard-table",
  columns: [
    {
      id: "color",
      type: "color",
      label: "",
      align: "center",
      width: "30px",
    },
    {
      id: "name",
      type: "text",
      label:
        type === "MY_TIMESHEET_PROJECT"
          ? "MY_TIMESHEET_PROJECT"
          : type === "OC_COST"
            ? "OC_COST"
            : type === "MY_TIMESHEET_CLIENT"
              ? "MY_TIMESHEET_CLIENT"
              : "",
      sort: true,
      search: true,
      width: "400px",
    },
    {
      id: "summaryTime",
      type: "text",
      label: "MY_TIMESHEET_DURATION",
      sort: true,
      width: "120px",
    },
    {
      id: "summaryCost",
      type: "text",
      label: "OC_COST",
      sort: true,
      width: "120px",
    },
  ],
});

export const myTimesheetMyRequestsDashboardTableIsMobile = (
  type: "MY_TIMESHEET_PROJECT" | "OC_COST" | "MY_TIMESHEET_CLIENT",
) => ({
  id: "my-time-sheet-my-requests-dasboard-table",
  select: "row",
  columns: [
    {
      id: "color",
      type: "color",
      label: "",
      align: "center",
      width: "30px",
    },
    {
      id: "name",
      type: "text",
      label: type || "",
      sort: true,
      search: true,
      width: "100%",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
});

export const entitySettingsTableDef = {
  id: "my-sheet-entyty-settings-table-def",
  columns: [
    {
      id: "color",
      type: "color",
      label: "",
      align: "center",
      width: "30px",
    },
    {
      id: "name",
      label: "OC_NAME",
      sortable: true,
      align: "left",
      search: true,
      sort: true,
    },
    {
      id: "description",
      label: "MY_TIMESHEET_DETAILS",
      sort: true,
      align: "left",
    },
    {
      id: "editButton",
      label: "",
      type: "mySheetEditButton",
      align: "center",
      width: "50px",
    },
  ],
};

export const entitySettingsTableDefIsMobile = {
  id: "my-sheet-entyty-settings-table-def",
  select: "row",
  columns: [
    {
      id: "color",
      type: "color",
      label: "",
      align: "center",
      width: "30px",
    },
    {
      id: "name",
      label: "OC_NAME",
      sortable: true,
      align: "left",
      search: true,
      sort: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const costSettingsTableDef = {
  id: "my-sheet-costs-settings-table-def",
  columns: [
    {
      id: "color",
      type: "color",
      label: "",
      align: "center",
      width: "30px",
    },
    {
      id: "name",
      label: "OC_NAME",
      align: "left",
      search: true,
      sort: true,
    },
    {
      id: "value",
      label: "OC_COST",
      type: "currency",
      sort: true,
      align: "right",
      width: "100px",
    },
    {
      id: "billable",
      label: "MY_TIMESHEET_BILLABLE_COST",
      type: "billable",
      align: "center",
      width: "100px",
    },
    {
      id: "description",
      label: "MY_TIMESHEET_DETAILS",
      sort: true,
      align: "left",
    },
    {
      id: "editButton",
      label: "",
      type: "mySheetEditButton",
      align: "center",
      width: "50px",
    },
  ],
};

export const costSettingsTableDefIsMobile = {
  id: "my-sheet-costs-settings-table-def",
  select: "row",
  columns: [
    {
      id: "color",
      type: "color",
      label: "",
      align: "center",
      width: "30px",
    },
    {
      id: "name",
      label: "OC_NAME",
      align: "left",
      search: true,
      sort: true,
    },
    {
      id: "billable",
      label: "MY_TIMESHEET_BILLABLE_COST",
      type: "billable",
      align: "center",
      width: "100px",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const myTimesheetEmplyeeRequestsTable = {
  id: "my-time-sheet-employee-requests-table",
  select: "row",
  columns: [
    {
      id: "name",
      type: "text",
      label: "OC_NAME",
    },
    {
      id: "projectName",
      type: "text",
      label: "MY_TIMESHEET_PROJECT",
    },
    {
      id: "clientName",
      type: "text",
      label: "MY_TIMESHEET_CLIENT",
    },
    {
      id: "startTime",
      type: "text",
      label: "OC_START_TIME",
      width: "80px",
    },
    {
      id: "endTime",
      type: "text",
      label: "OC_END_TIME",
      width: "80px",
    },
    {
      id: "duration",
      type: "text",
      label: "MY_TIMESHEET_DURATION",
      width: "100px",
    },
    {
      id: "createdAt",
      type: "text",
      label: "OC_REQUEST_CREATED_AT",
      width: "140px",
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      width: "80px",
      align: "center",
    },
    {
      id: "messages",
      label: "",
      align: "center",
      type: "messageIndicator",
      width: "70px",
    },
  ],
};

export const myTimesheetEmplyeeRequestsTableIsMobile = {
  id: "my-time-sheet-employee-requests-table",
  select: "row",
  columns: [
    {
      id: "name",
      type: "text",
      label: "OC_NAME",
    },
    {
      id: "duration",
      type: "text",
      label: "MY_TIMESHEET_DURATION",
    },
    {
      id: "createdAt",
      type: "text",
      label: "OC_REQUEST_CREATED_AT",
      align: "center",
    },
    {
      id: "state",
      type: "state",
      label: "OC_STATE",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
    },
  ],
};
